/** Chaves da cache do chat entre pessoas (`/chat`). Num sítio só: os eventos em tempo real escrevem nas mesmas. */

export const CHAT_ROOT = ["chat"] as const;

export const chatKeys = {
  overview: () => [...CHAT_ROOT, "overview"] as const,
  conversation: (id: string) => [...CHAT_ROOT, "conversation", id] as const,
  /** Uma janela de mensagens: a conversa principal (`main`) ou as respostas de uma thread. */
  window: (id: string, threadRootId: string | null) => [...CHAT_ROOT, "messages", id, threadRootId ?? "main"] as const,
  windowsOf: (id: string) => [...CHAT_ROOT, "messages", id] as const,
  members: (id: string) => [...CHAT_ROOT, "members", id] as const,
  log: (id: string) => [...CHAT_ROOT, "log", id] as const,
  channels: (q: string, includeArchived: boolean) => [...CHAT_ROOT, "channels", q, includeArchived] as const,
};
